import Grid from '@material-ui/core/Grid';

import Tooltip from '~/components/RedesignedTooltip';
import QuestionIcon from '~/images/QuestionIcon.svg';

import Bit from './Bit';
import styles from './QuadBit.style';

const QuadBitContext = React.createContext();

const QuadBit = ({
  loading,
  classes,
  children,
  horizontal,
  title,
  actions,
  ...props
}) => {
  return (
    <QuadBitContext.Provider value={{ horizontal, loading }}>
      <Bit {...props} className={classes.bit}>
        <Bit.Header>
          {title && <Bit.Title>{title}</Bit.Title>}
          {actions && <Bit.Actions>{actions}</Bit.Actions>}
        </Bit.Header>
        <Grid className={classes.grid} container>
          {children}
        </Grid>
      </Bit>
    </QuadBitContext.Provider>
  );
};

QuadBit.propTypes = {
  loading: PropTypes.bool,
  classes: PropTypes.object,
  children: PropTypes.node,
  actions: PropTypes.node,
  title: PropTypes.string,
  horizontal: PropTypes.bool,
};

export const Metric = ({
  title,
  value,
  color,
  subtitle,
  classes,
  explanation,
  ...rest
}) => {
  const { horizontal, loading } = useContext(QuadBitContext);

  return (
    <Grid
      xs={6}
      md={horizontal ? 3 : 6}
      item
      className={classnames(classes.item, {
        [classes.horizontal]: horizontal,
      })}
      {...rest}>
      <span>
        {title}
        {explanation && (
          <div className={classes.itemExplanation}>
            <Tooltip placement="top" title={explanation}>
              <QuestionIcon />
            </Tooltip>
          </div>
        )}
      </span>
      <span
        style={{ color }}
        className={classnames({ 'ck-skeleton': loading })}>
        {loading ? 'Loading' : value}
      </span>
      <span className={classnames({ 'ck-skeleton': loading })}>{subtitle}</span>
    </Grid>
  );
};

Metric.propTypes = {
  classes: PropTypes.object,
  color: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  explanation: PropTypes.string,
};

QuadBit.Metric = withStyles(styles)(Metric);

export default withStyles(styles)(QuadBit);
